<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title="panelTitle")
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="$t('ui.refresh')" isModal=false type="button" @click="submit")
            b-row.mb-2
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-breadcrumb.bg-grey-transparent-2.p-l-10
                  b-breadcrumb-item(
                    :text="$t('ui.partner_list')"
                    @click="goPartnerList"
                  )
                  b-breadcrumb-item(
                    :text="sportLabel"
                    @click="goMarketList"
                  )
                  b-breadcrumb-item.active(:text="marketLabel")
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.tblAgent.table-sm.table-hover.table-bordered(
                  show-empty
                  :empty-text="$t('message.no_records')"
                  responsive
                  :items="betTypeList"
                  :fields="fields"
                  :busy="loading"
                )
                  template(v-slot:table-busy)
                    .text-center.text-primary.my-2
                      b-spinner.align-middle(small)
                      span.ml-2 {{ $t("ui.refresh") }}...
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(name_en)="row")
                    span(v-if="displayBetType(row.item)") #[b {{ displayBetType(row.item) }}]
                    span.text-muted(v-else) -
                  template(v-slot:cell(settings)="row")
                    b-button.partner-settings-btn(
                      type="button"
                      size="sm"
                      variant="warning"
                      v-b-modal.upsertPartnerBetType
                      :title="$t('ui.edit')"
                      @click="openUpsertModal(row.item)"
                    )
                      span.partner-settings-ldiff {{ formatNumber(row.item.ldiff) }}
                      span.partner-settings-sep /
                      span.partner-settings-margin {{ formatNumber(row.item.margin) }}
                  template(v-slot:cell(created)="row")
                    .d-flex.flex-column.align-items-end
                      span(v-if="row.item.created_by") #[b {{ row.item.created_by }}]
                      span.text-muted(v-else) -
                      span.text-muted(:title="row.item.created_on") {{ formatDate(row.item.created_on) }}
                  template(v-slot:cell(updated)="row")
                    .d-flex.flex-column.align-items-end
                      span(v-if="row.item.updated_by") #[b {{ row.item.updated_by }}]
                      span.text-muted(v-else) -
                      span.text-muted(:title="row.item.updated_on") {{ formatDate(row.item.updated_on) }}

      upsertPartnerBetType(:selected="selectedItem" @clicked="submit")
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import upsertPartnerBetType from "@/components/modal/upsertPartnerBetType.vue";

export default {
  components: {
    SubmitButton,
    upsertPartnerBetType
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betTypeList: [],
      selectedItem: {}
    };
  },
  computed: {
    sportsType() {
      return this.$store.getters.getSelectedSportsType;
    },
    marketType() {
      return this.$store.getters.getSelectedMarketType;
    },
    sportLabel() {
      const name = this.$store.getters.getSelectedSportsName;
      if (name) {
        return String(name).toUpperCase();
      }
      return this.sportsType !== undefined && this.sportsType !== null && this.sportsType !== ""
        ? String(this.sportsType)
        : "-";
    },
    marketLabel() {
      return this.displayMarketType(this.marketType) || "-";
    },
    panelTitle() {
      return this.$t("ui.partner_list") + " - " + this.sportLabel + " - " + this.marketLabel;
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: { width: "5%" }
        },
        {
          key: "name_en",
          label: this.$t("ui.bet_type"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: { width: "20%" }
        },
        {
          key: "settings",
          label: this.$t("ui.ldiff_margin"),
          class: "align-middle text-center",
          thClass: "bg-grey text-center",
          thStyle: { width: "25%" }
        },
        {
          key: "created",
          label: this.$t("ui.created_by_on"),
          class: "align-middle text-right",
          thClass: "bg-grey text-right",
          thStyle: { width: "25%" }
        },
        {
          key: "updated",
          label: this.$t("ui.updated_by_on"),
          class: "align-middle text-right",
          thClass: "bg-grey text-right",
          thStyle: { width: "25%" }
        }
      ];
    }
  },
  mounted() {
    if (
      this.sportsType === undefined ||
      this.sportsType === null ||
      this.sportsType === "" ||
      this.marketType === undefined ||
      this.marketType === null ||
      this.marketType === ""
    ) {
      this.goPartnerList();
      return;
    }
    this.submit();
  },
  methods: {
    displayMarketType(marketType) {
      const type = Number(marketType);
      if (type === 1) {
        return this.$t("ui.early").toUpperCase();
      }
      if (type === 2) {
        return this.$t("ui.today").toUpperCase();
      }
      if (type === 3) {
        return this.$t("ui.live").toUpperCase();
      }
      return "";
    },
    displayBetType(item) {
      return String(item.name_en || item.bet_type_name || item.bet_type || "").toUpperCase();
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value;
      }
      return num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4
      });
    },
    formatDate(value) {
      if (!value) {
        return "-";
      }
      return this.$moment(value).isValid()
        ? this.$moment(value).format("YYYY-MM-DD HH:mm:ss")
        : value;
    },
    goPartnerList() {
      this.$router.push("/partnerList");
    },
    goMarketList() {
      this.$router.push("/partnerMarketList");
    },
    openUpsertModal(item) {
      this.selectedItem = Object.assign({}, item, {
        sports_type:
          item.sports_type !== undefined && item.sports_type !== null
            ? item.sports_type
            : this.sportsType,
        market_type:
          item.market_type !== undefined && item.market_type !== null
            ? item.market_type
            : this.marketType,
        sports_name: this.$store.getters.getSelectedSportsName || ""
      });
    },
    submit() {
      this.loading = true;
      this.$store
        .dispatch("user/getPartnerSettingBetType")
        .then(response => {
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (response.success == true) {
            const list = response.data || [];
            const selectedSportsType = String(this.sportsType);
            const selectedMarketType = String(this.marketType);
            this.betTypeList = list.filter(item => {
              return (
                item &&
                item.sports_type !== undefined &&
                item.sports_type !== null &&
                String(item.sports_type) === selectedSportsType &&
                item.market_type !== undefined &&
                item.market_type !== null &&
                String(item.market_type) === selectedMarketType
              );
            });
          } else {
            this.betTypeList = [];
          }
        })
        .catch(response => {
          this.loading = false;
          this.betTypeList = [];
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.partner-settings-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 140px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.partner-settings-ldiff,
.partner-settings-margin {
  flex: 1 1 0;
  min-width: 0;
  font-variant-numeric: tabular-nums;
}

.partner-settings-ldiff {
  text-align: right;
}

.partner-settings-margin {
  text-align: left;
}

.partner-settings-sep {
  flex: 0 0 auto;
  width: 1rem;
  text-align: center;
}
</style>
